import { endOfDay, startOfDay, subDays } from 'date-fns';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import {
  PopoverHeader,
  UncontrolledPopover,
} from 'reactstrap';

import { getCarriersOptions } from '../../app/store/actions/carriers';
import {
  getOutboundOrdersDashboardInfo, setDashboardCurrentRange,
  setDashboardOutboundOrdersDates,
  setSelectedUserBranches,
} from '../../app/store/actions/outboundOrders';
import { getOrdersTypeOptions } from '../../app/store/actions/typeOrder';

import { getDailyLoadsList, getDailyLoadDashboardData } from '../../app/store/actions/dailyLoads';

import DateRangePicker from '../../components/date/DateRangePicker.jsx';
import FilterSelectionList from '../../components/form/filterSelectionList';

import DynamicCards from '../../components/dynamicCards/dynamicCards';
import DigitalClock from '../../components/digitalClock/digitalClock';
import ROUTES from '../../config/routes';
import WikiHelp from '../../components/tooltip/wikiHelp';

class DailyLoadDashboard extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      typeDashboard: 'Document',
    };

    this.breadcrumb = [
      { value: I18n.t('BEE42' /* Dashboard */), iconClassName: 'fa fa-chart-line m-t-10 m-r-5' },
      { value: I18n.t('BEE41' /* Expedição */) },
      { value: I18n.t('BEE4168' /* Status de Carregamento */), active: true },
    ];
  }

  async componentDidMount() {
    if (!this.props.location.state || !Object.keys(this.props.location.state).length) {
      const startDate = moment().subtract(30, 'd');
      const endDate = moment();
      const dates = { startDate, endDate };

      await this.props.setDashboardOutboundOrdersDates(dates);

      await this.getOutboundOrders();

      const listOrderTypes = await this.props.getOrdersTypeOptions();

      this.setState({
        listOrderTypes,
      });
    }

    await this.getDailyLoads(); // Aguarde a execução da função assíncrona

    this.props.history.push({
      state: {},
    });
  }

  getDailyLoads = async () => {
    const {
      startDate, endDate,
    } = this.props.dates;

    const branchesToSearch = [];
    if (this.props.selectedBranches) {
      this.props.selectedBranches.map(({ value }) => branchesToSearch.push(value));
    }

    const orderTypesToSearch = [];
    if (this.state.selectedOrderTypes) {
      this.state.selectedOrderTypes.map(({ value }) => orderTypesToSearch.push(value));
    }

    const dailyLoadsList = await this.props.getDailyLoadDashboardData({
      startDate,
      endDate,
      branchesToSearch,
      orderTypesToSearch,
    });

    const today = new Date().getDay();
    const todayDate = new Date().getDate();

    const filteredDailyLoadsList = dailyLoadsList.filter((load) => {
      if (load.collectionDayOption === 2) {
        // Verifica se o dia atual é de segunda (1) a sexta (5)
        return today >= 1 && today <= 5;
      }

      if (load.collectionDayOption === 3) {
        const collectionDays = JSON.parse(load.collectionDayValues);

        // Verifica se o dia(segunda a domingo) atual está no array de dias permitidos
        return collectionDays.includes(today);
      }

      if (load.collectionDayOption === 4) {
        const collectionDays = JSON.parse(load.collectionDayValues);

        // Verifica se o dia do mês(numero do dia do mês) atual está no array
        return collectionDays.includes(todayDate);
      }
      return true;
    });

    this.setState({
      dailyLoadsList: filteredDailyLoadsList,
    });
  };

  getOutboundOrders = async () => {
    const {
      startDate, endDate,
    } = this.props.dates;
    const { currentRange } = this.props;

    const branchesToSearch = [];
    if (this.props.selectedBranches) {
      this.props.selectedBranches.map(({ value }) => branchesToSearch.push(value));
    }

    const orderTypesToSearch = [];
    if (this.state.selectedOrderTypes) {
      this.state.selectedOrderTypes.map(({ value }) => orderTypesToSearch.push(value));
    }

    const carriersToSearch = [];
    if (this.state.selectedCarriers) {
      this.state.selectedCarriers.map(({ value }) => carriersToSearch.push(value));
    }

    await this.props.getOutboundOrdersDashboardInfo(
      startDate,
      endDate,
      true,
      branchesToSearch,
      currentRange,
      orderTypesToSearch,
      carriersToSearch,
      this.state.typeDashboard,
    );
  };

  handleDateApplyEvent = async (value) => {
    const startDate = value[0];
    const endDate = value[1];

    const dates = { startDate, endDate };
    await this.props.setDashboardOutboundOrdersDates(dates);
  };

  handleBranchesSelected = async (event) => {
    const selectedBranches = [];

    event.map((element) => selectedBranches.push({
      value: element.value,
      label: element.label,
    }));

    await this.props.setSelectedUserBranches(selectedBranches);
  };

  handleOrderTypesSelected = async (event) => {
    const selectedOrderTypes = [];

    event.map((element) => selectedOrderTypes.push({
      value: element.value,
      label: element.label,
    }));

    this.setState({
      selectedOrderTypes: selectedOrderTypes || {},
    });
  };

  render() {
    const {
      listOrderTypes, dailyLoadsList,
    } = this.state;
    const startDate = (this.props.dates && this.props.dates.startDate) || startOfDay(subDays(new Date(), 30));
    const endDate = (this.props.dates && this.props.dates.endDate) || endOfDay(new Date());

    return (
      <div>
        <div style={{ display: 'flex', width: '100%' }}>
          {/* Bloco Esquerdo */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            {/* Caminho (Breadcrumb) */}
            {!!this.breadcrumb && this.breadcrumb.length && (
              <div className="d-flex align-items-center">
                <ol className="breadcrumb mb-2">
                  {this.breadcrumb.map((it, index) => (
                    <li key={`${it.value}${index}`} className={`breadcrumb-item${it.active ? ' active' : ''}`}>
                      {it.iconClassName ? (
                        <>
                          <i className="fa fa-chart-line m-t-10 m-r-5" />
                          {' '}
                          {it.value}
                        </>
                      ) : (
                        it.value
                      )}
                    </li>
                  ))}
                </ol>
              </div>
            )}

            {/* Título */}
            <div className="d-flex align-items-center">
              <h1 className="page-header mb-0">
                {I18n.t('BEE4168' /* Status de Carregamento */)}
              </h1>
              <WikiHelp wikiPath={ROUTES.DAILY_LOAD_DASHBOARD_HELP} />
            </div>

            {/* Filtros */}
            <div className="d-sm-flex">
              <div className="d-flex mt-2">
                <DateRangePicker
                  onChange={(value) => this.handleDateApplyEvent(value)}
                  defaultValue={[new Date(startDate), new Date(endDate)]}
                />
                <UncontrolledPopover trigger="hover" placement="top" target="dateRangePicker">
                  <PopoverHeader>
                    {I18n.t('BEE3342', {
                      0: I18n.t('BEE3344' /* data de criação */),
                    } /* O intervalo segue o critério pela %{0} */)}
                  </PopoverHeader>
                </UncontrolledPopover>
              </div>

              {/* Filiais */}
              <div className="d-flex mt-2">
                <FilterSelectionList
                  value={this.props.selectedBranches}
                  onChangeValue={this.handleBranchesSelected}
                  placeholderValue={I18n.t('BEE2424' /* Todas as filiais estão selecionadas */)}
                  optionsValue={this.props.userBranches}
                  onClickValue={this.getDailyLoads}
                />
              </div>

              {/* Tipo de Documento */}
              <div className="d-flex mt-2 ml-1">
                <FilterSelectionList
                  value={this.props.selectedOrderTypes}
                  onChangeValue={this.handleOrderTypesSelected}
                  placeholderValue={I18n.t('BEE3355' /* Todos os tipos de documentos estão selecionados. */)}
                  optionsValue={listOrderTypes}
                  onClickValue={this.getDailyLoads}
                />
              </div>
            </div>
          </div>

          {/* Bloco Direito (Relógio) */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <DigitalClock onCheckboxChange={this.getDailyLoads} />
          </div>
        </div>

        <div>
          <h2 className="page-header mb-0 mt-4">
            { }
          </h2>
          {typeof dailyLoadsList === 'object' && dailyLoadsList !== null && dailyLoadsList.length ? (
            <DynamicCards data={dailyLoadsList} />
          ) : (
            <p>{I18n.t('BEE4187' /* Nenhum registro disponível. */)}</p>
          )}

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  outboundOrdersList: state.outboundOrders && state.outboundOrders.outboundOrdersList,
  userBranches: state.outboundOrders.userBranches,
  dates: state.outboundOrders.dates,
  currentRange: state.outboundOrders.currentRange,
  selectedBranches: state.outboundOrders.selectedBranches,
  lineChartCheckData: state.outboundOrders && state.outboundOrders.chartsPanel.lineChartCheck,
  doughnutChartData: state.outboundOrders && state.outboundOrders.chartsPanel.lineProductStatus,
});

const mapDispatchToProps = (dispatch) => ({
  getOutboundOrdersDashboardInfo:
    (
      startDate,
      endDate,
      getCharts,
      selectedBranches,
      currentRange,
      selectedOrderTypes,
      selectedCarriers,
      typeDashboard,
    ) => dispatch(getOutboundOrdersDashboardInfo(
      startDate,
      endDate,
      getCharts,
      selectedBranches,
      currentRange,
      selectedOrderTypes,
      selectedCarriers,
      typeDashboard,
    )),
  setDashboardCurrentRange: (currentRange) => dispatch(setDashboardCurrentRange(currentRange)),
  setSelectedUserBranches: (selectedBranches) => dispatch(setSelectedUserBranches(selectedBranches)),
  getOrdersTypeOptions: () => dispatch(getOrdersTypeOptions()),
  getCarriersOptions: () => dispatch(getCarriersOptions()),
  setDashboardOutboundOrdersDates: (dates) => dispatch(setDashboardOutboundOrdersDates(dates)),
  getDailyLoadsList: () => dispatch(getDailyLoadsList()),
  getDailyLoadDashboardData: (parameters) => dispatch(getDailyLoadDashboardData(parameters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DailyLoadDashboard));
